import moment from 'moment';
import { createCalendarEventsFromRegistry } from './features/registry';

const DEFAULT_MAX_YEARS_BACK = 5;
const DEFAULT_LIMIT = 25;

const parseInputDate = (value) => {
  if (value instanceof Date) {
    const date = moment(value);
    return date.isValid() ? date : null;
  }

  if (typeof value === 'string') {
    const date = moment(value, moment.ISO_8601, true);
    return date.isValid() ? date : null;
  }

  const date = moment(value);
  return date.isValid() ? date : null;
};

const getEventMoment = (event) => {
  if (!event?.start) return null;
  return parseInputDate(event.start);
};

export const getAnniversariesForDate = (selectedDate, events, options = {}) => {
  const targetDate = parseInputDate(selectedDate);
  if (!targetDate) return [];

  const maxYearsBack = Number.isFinite(options.maxYearsBack)
    ? options.maxYearsBack
    : DEFAULT_MAX_YEARS_BACK;
  const limit = Number.isFinite(options.limit) ? options.limit : DEFAULT_LIMIT;
  const minYear = targetDate.year() - maxYearsBack;

  return (events || [])
    .map((event, index) => {
      const eventMoment = getEventMoment(event);
      if (!eventMoment) return null;
      if (eventMoment.year() >= targetDate.year()) return null;
      if (eventMoment.year() < minYear) return null;
      if (eventMoment.month() !== targetDate.month()) return null;
      if (eventMoment.date() !== targetDate.date()) return null;

      return {
        id: event.id || event.resource?.routeId || `${event.title || 'event'}-${eventMoment.toISOString()}-${index}`,
        title: event.title || 'Evento',
        start: event.start,
        end: event.end,
        allDay: event.allDay,
        year: eventMoment.year(),
        ageYears: targetDate.year() - eventMoment.year(),
        dateLabel: eventMoment.format('DD/MM/YYYY'),
        resource: event.resource || null,
      };
    })
    .filter(Boolean)
    .sort((a, b) => new Date(b.start) - new Date(a.start))
    .slice(0, limit);
};

export const buildAnniversaryItems = ({
  selectedDate,
  data,
  selectedTypes,
  routeItems,
  getMoodColor,
  focusedKey,
  maxYearsBack = DEFAULT_MAX_YEARS_BACK,
  limit = DEFAULT_LIMIT,
}) => {
  const calendarEvents = createCalendarEventsFromRegistry({
    data,
    selectedTypes,
    routeItems,
    getMoodColor,
    focusedKey,
  });

  return getAnniversariesForDate(selectedDate, calendarEvents, { maxYearsBack, limit });
};
